import React from 'react';
import { FiPause } from 'react-icons/fi';
import { getActiveProgressHold } from '../utils/progressHold';
import './ProgressHoldBanner.css';

const ProgressHoldBanner = ({ hold: holdProp }) => {
  const hold = holdProp || getActiveProgressHold();
  if (!hold || !hold.end_date) {
    return null;
  }

  const isActive = hold.status === 'active' || hold.active;
  const label = isActive
    ? `Progression paused until ${hold.end_date}. Your subscription stays active.`
    : `Progression pause scheduled from ${hold.start_date} to ${hold.end_date}. Your subscription stays active.`;

  return (
    <div className="progress-hold-banner" role="status">
      <FiPause size={16} />
      <p>{label}</p>
      <a href="/settings">Manage</a>
    </div>
  );
};

export default ProgressHoldBanner;
